import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconPlus = forwardRef<SVGSVGElement, IconProps>(function IconPlus(
  props,
  ref,
) {
  const { className, title, titleId, ...otherProps } = props
  const defaultClasses =
    "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      ref={ref}
      viewBox="0 0 32 32"
      fill="none"
      focusable="false"
      aria-hidden="true"
      tabIndex={-1}
      className={classes}
      aria-labelledby={titleId}
      {...otherProps}
    >
      {title ? <title id={titleId}>{title}</title> : null}

      <path
        d="M27.5297 15.3999H16.1297V3.9999C16.1297 3.84077 16.0665 3.68816 15.954 3.57564C15.8414 3.46312 15.6888 3.3999 15.5297 3.3999C15.3706 3.3999 15.2179 3.46312 15.1054 3.57564C14.9929 3.68816 14.9297 3.84077 14.9297 3.9999V15.3999H3.52969C3.37056 15.3999 3.21794 15.4631 3.10542 15.5756C2.9929 15.6882 2.92969 15.8408 2.92969 15.9999C2.92969 16.159 2.9929 16.3116 3.10542 16.4242C3.21794 16.5367 3.37056 16.5999 3.52969 16.5999H14.9297V27.9999C14.9297 28.159 14.9929 28.3116 15.1054 28.4242C15.2179 28.5367 15.3706 28.5999 15.5297 28.5999C15.6888 28.5999 15.8414 28.5367 15.954 28.4242C16.0665 28.3116 16.1297 28.159 16.1297 27.9999V16.5999H27.5297C27.6888 16.5999 27.8414 16.5367 27.954 16.4242C28.0665 16.3116 28.1297 16.159 28.1297 15.9999C28.1297 15.8408 28.0665 15.6882 27.954 15.5756C27.8414 15.4631 27.6888 15.3999 27.5297 15.3999Z"
        fill="currentColor"
      />
    </svg>
  )
})
